import { render, staticRenderFns } from "./focus_side_bar.vue?vue&type=template&id=39c7f576&"
import script from "./focus_side_bar.vue?vue&type=script&lang=js&"
export * from "./focus_side_bar.vue?vue&type=script&lang=js&"
import style0 from "./focus_side_bar.vue?vue&type=style&index=0&lang=less&socped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports